import './NoAnnotationTypesWarningContainer.scss';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { IAnnotationsStore } from '../annotations.store';
import { IAnnotationTypeStore } from '../submodules/annotationTypes/annotationType.store';

export const NoAnnotationTypesWarningContainer = observer((): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const annotationTypeStore = useInjection(IAnnotationTypeStore.$);

  const { t } = useTranslator();
  const hasNoToolsOrQuestionsSpecified = !annotationsStore.questions.length && !annotationTypeStore.annotationTypes.length;

  return hasNoToolsOrQuestionsSpecified ? (
    <ColumnLayout
      size='md'
      className='free-access-actions-warning'
    >
      <div className='warning'>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {t('warning')}
      </div>
      <div>
        <span className='text-center'>{t('one_marking_tool_or_question_has_to_be_added')}</span>
      </div>
    </ColumnLayout>
  ) : (
    <></>
  );
});
